// function 提供高鐵版表格使用
// THSR: thsr_monitor
import { generate_sign_icon_html } from "@/utils/monitor/multiple_signs.js"

export const icons = {
    '雨量警示': {
        '預警': {color: 'yellow',},
        '警戒': {color: 'orange',},
        '行動': {color: 'red',},
        name: 'icon-rainfall-warning',
        show_opacity: true,
        color: 'blue'
    },
    '大風警示': {
        '預警': {color: 'yellow'},
        '警戒': {color: 'orange'},
        '行動': {color: 'red'},
        name: 'icon-gale-warning',
        show_opacity: true,
        color: 'blue'
    },
}

export const reconstruct_signs_structure = (data) => {
    return data.map(datum => {
        return {
            "idx": `
                ${datum['項次']}
            `,
            "idx_for_sort": datum['項次'],
            "sign_icons" : generate_sign_icon_html(datum, icons)
        }
    })
}